import { Mail } from 'lucide-react';

export function Footer() {
	return (
		<footer className="bg-gray-900 text-white py-12">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid md:grid-cols-3 gap-8">
					<div>
						<div className="flex items-center space-x-2 mb-4">
							<Mail className="h-6 w-6 text-emerald-400" />
							<span className="text-lg font-bold">NOS Email</span>
						</div>
						<p className="text-gray-400">
							Intelligent email routing for cold outreach that actually reaches
							inboxes.
						</p>
					</div>
					<div>
						<h4 className="font-semibold mb-4">Quick Links</h4>
						<div className="space-y-2 text-gray-400">
							<a href="/" className="block hover:text-white transition-colors">
								Home
							</a>
							<a href="/login" className="block hover:text-white transition-colors">
								Login
							</a>
							<a href="/signup" className="block hover:text-white transition-colors">
								Sign Up
							</a>
						</div>
					</div>
					<div>
						<h4 className="font-semibold mb-4">Legal</h4>
						<div className="space-y-2 text-gray-400">
							<a href="/privacy" className="block hover:text-white transition-colors">
								Privacy Policy
							</a>
							<a href="/terms" className="block hover:text-white transition-colors">
								Terms of Service
							</a>
						</div>
					</div>
				</div>
				<div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
					<p>&copy; 2025 NOS Email. All rights reserved.</p>
				</div>
			</div>
		</footer>
	);
}
